import React, { useMemo } from 'react';
import CompareTooltip from './CompareTooltip';
import {EngagementCommentStatus} from '../../../../../../../../util/uiconstants';

function AGGridCommentCountCellRenderer({data, value, commentType}) {
	const commentcounts = useMemo(() => {
		switch (commentType) {
			case EngagementCommentStatus.open:
				return data?.openCommentCount;
			case EngagementCommentStatus.cleared:
				return data?.clearedCommentCount;
			default:
				return 0;
		}
	}, [data, commentType]);

	return (
		<CompareTooltip data={data} value={value} commentType={commentType} renderer={<section className="trigger-count">{commentcounts}</section>} />
	);
}

export default AGGridCommentCountCellRenderer;
